import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import { useAppSelector } from '../../../../redux/hooks';
import { insertAt } from '../../../../utils/insertAt';
import { Table } from '../../../../components/Table';
import { CountrySwitch } from '../CountrySwitch';
import { TableImage } from '../TableImage';
import './AttachmentsTable.scss';
import { Actions } from './components/Actions/Actions';
import { Order } from './components/Order/Order';
export var AttachmentsTable = function (_a) {
    var isLoading = _a.isLoading, isFetched = _a.isFetched, setDialogData = _a.setDialogData;
    var _b = useAppSelector(function (state) { return state.attachments; }), attachments = _b.attachments, currency = _b.currency;
    var dataMemoized = useMemo(function () { return attachments; }, [attachments]);
    var isPriceExist = dataMemoized === null || dataMemoized === void 0 ? void 0 : dataMemoized.some(function (item) { return item.price; });
    var columns = useMemo(function () { return [
        {
            id: 'id',
            Header: function () { return _jsx("span", {}); },
            columns: [
                {
                    accessor: 'image',
                    Cell: function (_a) {
                        var row = _a.row, value = _a.value;
                        return (_jsx(TableImage, { id: row.id, value: value, partNumber: row.original.partNumber }));
                    },
                },
                {
                    accessor: 'partNumber',
                    Header: 'Part Number',
                },
                {
                    accessor: 'description',
                    Header: 'Description',
                },
            ],
        },
        {
            id: 'fitmentNote',
            Header: '',
            columns: [
                {
                    accessor: 'fitmentNotes',
                    Header: function () { return (_jsxs("span", { className: "Availability-Header", children: [_jsx("span", { className: "Availability-Header-Primary", children: "Availability" }), _jsx("span", { className: "Availability-Header-Secondary", children: "Specifications" })] })); },
                    Cell: function (_a) {
                        var value = _a.value, original = _a.row.original;
                        return (_jsx(Actions, { value: value, attachment: original, setDialogData: setDialogData }));
                    },
                },
            ],
        },
        {
            id: 'order',
            Header: '',
            columns: [
                {
                    accessor: 'orders',
                    Header: 'Order',
                    Cell: function (_a) {
                        var original = _a.row.original;
                        return (_jsx(Order, { partNumber: original.partNumber, description: original.description, price: original.price }));
                    },
                },
            ],
        },
    ]; }, [currency]);
    if (isPriceExist && columns.every(function (column) { return column.id !== 'price'; })) {
        insertAt(columns, 1, {
            id: 'price',
            Header: function () { return _jsx(CountrySwitch, {}); },
            columns: [
                {
                    accessor: 'price',
                    Header: 'List-Price',
                    Cell: function (_a) {
                        var _b;
                        var value = _a.value;
                        if (!value)
                            return _jsx("span", {});
                        var price = (_b = value[currency]) !== null && _b !== void 0 ? _b : null;
                        if (price) {
                            return _jsx("span", { children: "".concat(price.currency, " ").concat(price.price) });
                        }
                        return _jsx("span", {});
                    },
                },
                // {
                //   accessor: 'unit',
                //   Header: 'Unit',
                //   Cell: ({ }: Cell<Attachment>) => {
                //     if (
                //       Object.keys(original).length === 0 ||
                //       !original.price
                //     ) {
                //       return <span></span>
                //     }
                //     const price = original.price[currency]
                //     if (price) {
                //       return <span>{price.unit}</span>
                //     }
                //     return <span></span>
                //   },
                // },
            ],
        });
    }
    var classes = classNames('Attachments-Table', {
        'Attachments-Table-Overflow': !isLoading,
    });
    return (_jsx("div", { className: classes, children: isFetched && (dataMemoized === null || dataMemoized === void 0 ? void 0 : dataMemoized.length) === 0 ? (_jsx("div", { className: "Attachments-Table-No-Result", children: _jsx("h3", { children: "No results" }) })) : (_jsx(Table, { sortColumns: ['partNumber', 'description'], isLoading: isLoading, data: dataMemoized, columns: columns })) }));
};
